( function ( _s ) {
	_s.fn.header = function () {
		return this.each( header => {
			const _header = _s( header );
			const _notificationBar = _header.find( '.notification-bar' );
			const _desktopNavBar = _header.find( '.navbar-desktop' );
			const _mobileNavBar = _header.find( '.navbar-mobile' );
			const _navbarBrand = _header.find( '.navbar-brand' );
			const _logo = _navbarBrand.find( 'img' );

			const isSubmenuExpanded = _toggle => {
				return _toggle.hasClass( 'show' );
			};

			let autohideOnScrollHeight = parseInt( window.getRootProperty( '--body-top-padding' ) );
			let scrolled = 0;

			const scroll = () => {
				const currentScrollY = window.scrollY;

				_header.toggleClass(
					'show',
					currentScrollY < scrolled && ! _header.hasClass( 'locked-hidden' )
				);

				if ( currentScrollY < 1 && scrolled > 0 ) {
					_header.removeClass( 'navbar-fixed' );
				}

				if ( currentScrollY > scrolled && currentScrollY > autohideOnScrollHeight ) {
					_header.toggleClass( 'navbar-fixed', true );

					/** Add a small delay when adding the "animate" class */
					setTimeout( () => {
						_header.toggleClass( 'animate', true );
					}, 50 );
				}

				if ( currentScrollY <= autohideOnScrollHeight ) {
					_header.toggleClass( 'animate', false );
				}

				scrolled = currentScrollY;
			};

			const bodyOverflowHidden = ( lock = false ) => {
				if ( lock ) {
					_s( 'body' ).addClass( 'overflow-hidden' );
				} else {
					_s( 'body' ).removeClass( 'overflow-hidden' );
				}
			};

			_header.find( '.dropdown-toggle' ).removeAttr( 'data-bs-toggle' );

			_desktopNavBar.each( desktopNavBar => {
				const _dropdownContainers = _s( desktopNavBar ).find( '.menu-item-has-children' );
				const _dropdownToggles = _dropdownContainers.find( '.dropdown-toggle' );

				_dropdownToggles.each( dropdownToggle => {
					const _dropdownToggle = _s( dropdownToggle );
					const _dropdownContainer = _dropdownToggle.closest( '.menu-item-has-children' );
					const _dropdown = _dropdownContainer.find( '> .dropdown-menu' );
					const _dropdownItems = _dropdown.find( 'a.dropdown-item' );

					dropdownToggle.dropdownInstance =
						window.bs.Dropdown.getOrCreateInstance( dropdownToggle );

					_dropdownToggle.collapse = () => {
						_dropdownToggle.firstElement().dropdownInstance.hide();
					};

					_dropdownToggle.on( 'shown.bs.dropdown', () => {
						_dropdownToggle.closest( '.menu-item' ).addClass( 'dropdown-expanded' );
					} );

					_dropdownToggle.on( 'hidden.bs.dropdown', () => {
						_dropdownToggle.closest( '.menu-item' ).removeClass( 'dropdown-expanded' );
					} );

					_dropdownContainer.on( 'mouseenter', e => {
						if ( ! _dropdownToggle.hasClass( 'show' ) ) {
							dropdownToggle.dropdownInstance.show();
						}
					} );

					_dropdownContainer.on( 'mouseleave', e => {
						if ( _dropdownToggle.hasClass( 'show' ) ) {
							dropdownToggle.dropdownInstance.hide();
							dropdownToggle.blur();
						}
					} );

					_dropdownToggle.on( 'keydown', e => {
						if ( [ 'ArrowDown', 'ArrowUp' ].includes( e.key ) ) {
							e.preventDefault();
							if ( e.key == 'ArrowDown' ) {
								if ( ! isSubmenuExpanded( _dropdownToggle ) ) {
									dropdownToggle.dropdownInstance.show();
								} else {
									/** Set focus on the first item of the dropdown */
									const firstItem = _dropdownToggle
										.closest( '.menu-item' )
										.find( '> .dropdown-menu' )
										.find( 'a' )
										.firstElement();
									if ( firstItem ) {
										firstItem.focus();
									}
								}
							} else {
								dropdownToggle.dropdownInstance.hide();
							}
						}
						if ( e.key == 'ArrowRight' ) {
							const next = _dropdownToggle
								.closest( '.menu-item' )
								.firstElement().nextElementSibling;
							const _next = _s( next );

							if ( _next.hasClass( 'menu-item' ) ) {
								_next.find( '.dropdown-toggle' ).each( toggle => {
									toggle.focus();
								} );
							}
						}
						if ( e.key == 'ArrowLeft' ) {
							const previous = _dropdownToggle
								.closest( '.menu-item' )
								.firstElement().previousElementSibling;
							const _previous = _s( previous );

							if ( _previous.hasClass( 'menu-item' ) ) {
								_previous.find( '.dropdown-toggle' ).each( toggle => {
									toggle.focus();
								} );
							}
						}
					} );

					_dropdownToggle.on( 'blur', e => {
						const _relatedTarget = _s( e.relatedTarget );
						const targetItemClass = _relatedTarget
							.closest( '.menu-item' )
							.attr( 'class' );

						if (
							isSubmenuExpanded( _dropdownToggle ) &&
							! _dropdownToggle
								.closest( '.menu-item' )
								.find( '[class="' + targetItemClass + '"]' ).length
						) {
							dropdownToggle.dropdownInstance.hide();
						}
					} );

					_dropdownItems.on( 'blur', e => {
						const _relatedTarget = _s( e.relatedTarget );
						if ( ! _relatedTarget.closest( '.dropdown-expanded' ).length ) {
							dropdownToggle.dropdownInstance.hide();
						}
					} );

					const focusNext = _currentMenuItem => {
						if ( _currentMenuItem.length ) {
							let nextMenuItem = _currentMenuItem.firstElement().nextElementSibling;
							let _nextMenuItem = _s( nextMenuItem );

							if ( _nextMenuItem.length ) {
								_nextMenuItem.find( '> .dropdown-item' ).each( dropdownItem => {
									dropdownItem.focus();
								} );
							} else {
								focusNext(
									_currentMenuItem.closest( '.menu-item.menu-item-has-children' )
								);
							}
						}
					};

					const focusPrev = _currentMenuItem => {
						if ( _currentMenuItem.length ) {
							let previousMenuItem =
								_currentMenuItem.firstElement().previousElementSibling;
							let _previousMenuItem = _s( previousMenuItem );

							if ( _previousMenuItem.length ) {
								_previousMenuItem.find( 'a' ).lastElement().focus();
							} else if ( _currentMenuItem.closest( '.dropdown-menu' ).length ) {
								const _dropdownItem = _currentMenuItem
									.closest( '.menu-item.menu-item-has-children' )
									.find( '> a' );

								_dropdownItem.each( dropdownItem => {
									dropdownItem.focus();
								} );
							}
						}
					};

					_dropdownItems.on( 'keydown', e => {
						if ( ! [ 'ArrowUp', 'ArrowDown' ].includes( e.key ) ) return;

						const _item = _s( e.target );
						const _parent = _item.closest( '.menu-item' );

						if ( e.key === 'ArrowDown' ) {
							if ( _parent.hasClass( 'menu-item-has-children' ) ) {
								_parent
									.find( '> .dropdown-menu' )
									.find( '> .menu-item:first-child' )
									.find( 'a' )
									.each( menuItem => {
										menuItem.focus();
									} );
							} else {
								focusNext( _parent );
							}
						}

						if ( e.key === 'ArrowUp' ) {
							focusPrev( _parent );
						}
					} );
				} );
			} );

			_mobileNavBar.each( mobileNavBar => {
				const _mobileNavigationBar = _s( mobileNavBar );
				const _mobileNavbarDropdowns = _mobileNavigationBar.find(
					'.navbar-nav > .menu-item.menu-item-has-children'
				);
				const _mobileNavbarDropdownToggles =
					_mobileNavigationBar.find( '.dropdown-toggle' );

				_mobileNavigationBar.on( 'show.bs.collapse', () => {
					bodyOverflowHidden( true );
				} );

				_mobileNavigationBar.on( 'hide.bs.collapse', () => {
					bodyOverflowHidden();
				} );

				_mobileNavigationBar.each( mobileNavigationBar => {
					const collapseInstance =
						window.bs.Collapse.getInstance( mobileNavigationBar ) ||
						new window.bs.Collapse( mobileNavigationBar, { toggle: false } );
					mobileNavigationBar.collapseInstance = collapseInstance;
				} );

				_mobileNavbarDropdownToggles.each( mobileNavbarDropdownToggle => {
					mobileNavbarDropdownToggle.dropdownInstance =
						window.bs.Dropdown.getOrCreateInstance( mobileNavbarDropdownToggle );
				} );

				_mobileNavbarDropdowns.on( 'click', e => {
					const _target = _s( e.target );

					if (
						_target.hasClass( 'menu-item' ) &&
						! _target.closest( '.menu-item' ).length
					) {
						const _toggle = _target.find( '.dropdown-toggle' );

						_toggle.firstElement().dropdownInstance.toggle();
						_target.toggleClass(
							'submenu-expanded',
							_toggle.firstElement().dropdownInstance._isShown()
						);
					}
				} );
			} );

			/** Set the value for --notification-bar-height variable */
			const notificationBarHeight = () => {
				if ( _notificationBar.length ) {
					window.setRootProperty(
						'--notification-bar-height',
						parseInt( _notificationBar.outerHeight() ) + 'px'
					);
				}
			};

			const initLogorResizeObserver = () => {
				_logo.each( logo => {
					const logoResizeObserver = new ResizeObserver( () => {
						_s( window ).trigger( 'fr:logo-resized' );
					} );

					logoResizeObserver.observe( logo );
				} );
			};

			const initHeaderResizeObserver = () => {
				_header.each( header => {
					const headerResizeObserver = new ResizeObserver( entries => {
						for ( let entry of entries ) {
							const { height } = entry.contentRect;

							if ( entry.target.dataset.prevHeight !== height.toString() ) {
								entry.target.dataset.prevHeight = height.toString();

								_s( window ).trigger( 'fr:header-resized' );
							}
						}
					} );

					headerResizeObserver.observe( header );
				} );
			};

			_s( window ).on( 'scroll', () => {
				scroll();
			} );

			_s( window ).on( 'resize', () => {
				_s( window ).trigger( 'fr:set-body-top-padding' );
				notificationBarHeight();
			} );

			_s( window ).on( 'fr:set-body-top-padding-updated', () => {
				autohideOnScrollHeight = parseInt( window.getRootProperty( '--body-top-padding' ) );
			} );

			_s( window ).on( 'fr:logo-resized fr:header-resized', () => {
				_s( window ).trigger( 'fr:set-body-top-padding' );
			} );

			notificationBarHeight();

			initLogorResizeObserver();

			initHeaderResizeObserver();
		} );
	};

	_s( document ).ready( () => {
		_s( '#app > header' ).header();
	} );
} )( window._s );
